var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000096745422287023299710000008425786254455116467_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.1,21.6c-0.4-0.2-0.9-0.2-1.3,0l-3,1.8l-2,1.2l-3,1.8c-0.4,0.2-0.9,0.2-1.3,0L18.2,25 c-0.4-0.2-0.6-0.7-0.6-1.1V21c0-0.5,0.2-0.9,0.6-1.1l2.3-1.4c0.4-0.2,0.9-0.2,1.3,0l2.3,1.4c0.4,0.2,0.6,0.7,0.6,1.1v1.8l2-1.2v-1.8 c0-0.5-0.2-0.9-0.6-1.1l-4.3-2.6c-0.4-0.2-0.9-0.2-1.3,0l-4.4,2.6c-0.4,0.2-0.6,0.7-0.6,1.1V25c0,0.5,0.2,0.9,0.6,1.1l4.4,2.6 c0.4,0.2,0.9,0.2,1.3,0l3-1.7l2-1.2l3-1.7c0.4-0.2,0.9-0.2,1.3,0l2.3,1.4c0.4,0.2,0.6,0.7,0.6,1.1v2.8c0,0.5-0.2,0.9-0.6,1.1 l-2.3,1.4c-0.4,0.2-0.9,0.2-1.3,0l-2.3-1.4c-0.4-0.2-0.6-0.7-0.6-1.1v-1.8l-2,1.2v1.8c0,0.5,0.2,0.9,0.6,1.1l4.4,2.6 c0.4,0.2,0.9,0.2,1.3,0l4.4-2.6c0.4-0.2,0.6-0.7,0.6-1.1v-5.2c0-0.5-0.2-0.9-0.6-1.1L31.1,21.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.1,32.7v-4.3c0.5,0.6,1.3,0.9,2.3,0.9c2.5,0,4.2-1.8,4.2-4.5s-1.5-4.5-3.9-4.5c-1.1,0-2,0.4-2.5,1.1v-0.9 h-2.4v12.2H44.1z M46.1,27.2c-1.3,0-2.1-1-2.1-2.4c0-1.5,0.8-2.4,2.1-2.4c1.2,0,2.1,1,2.1,2.4C48.2,26.3,47.3,27.2,46.1,27.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,29.3c2.6,0,4.5-1.9,4.5-4.5s-1.9-4.5-4.5-4.5s-4.5,1.9-4.5,4.5S53.3,29.3,55.9,29.3z M55.9,27.2 c-1.3,0-2.2-1-2.2-2.4s0.9-2.4,2.2-2.4s2.2,1,2.2,2.4C58.1,26.2,57.2,27.2,55.9,27.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.3,29.2V16.7h-2.4v12.5H64.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,20.5l-1.8,5.6l-1.8-5.6h-2.4l3.1,8.6l-1.3,3.6h2.3l1.2-3.5l3.1-8.6h-2.4V20.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.5,21.3c-0.5-0.6-1.3-1-2.4-1c-2.5,0-4,1.8-4,4.5s1.5,4.5,4.1,4.5c1,0,1.9-0.4,2.4-1v1.1 c0,0.8-0.5,1.4-1.2,1.4h-4v1.9h4.3c1.9,0,3.2-1.2,3.2-3v-9.2h-2.4V21.3z M78.6,27.2c-1.3,0-2.1-0.9-2.1-2.4s0.8-2.4,2.1-2.4 c1.3,0,2.1,1,2.1,2.4C80.7,26.3,79.9,27.2,78.6,27.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.9,29.3c2.7,0,4.5-1.9,4.5-4.5s-1.9-4.5-4.5-4.5s-4.5,1.9-4.5,4.5S86.3,29.3,88.9,29.3z M88.9,27.2 c-1.3,0-2.2-1-2.2-2.4s0.9-2.4,2.2-2.4c1.3,0,2.2,1,2.2,2.4S90.2,27.2,88.9,27.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.2,29.2v-4.8c0-1.1,0.7-1.9,1.8-1.9c1,0,1.7,0.8,1.7,1.8v4.9h2.4v-5.4c0-2-1.3-3.4-3.2-3.4 c-1.2,0-2.1,0.5-2.6,1.3v-1.2h-2.4v8.7H97.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.e670333abfc593498d10dbe4cc6448cc.svg";
export { ForwardRef as ReactComponent };